import React, { PureComponent } from "react";

import Filter from "Common/Filter";
import MediaList from "Common/MediaList";
import AlbumList from "Common/AlbumList";
import Profile from "./Profile";

import styles from "./MyMedias.local.scss";
import profileStyles from "./Profile/Profile.local.scss";

export default class MyMediasComponent extends PureComponent {
  state = {
    displayMedias: true,
    displayAlbums: false,
    displayFavorites: false
  };

  handleChangeTab = (type, e) => {
    const tabs = document.getElementsByClassName(profileStyles.tab);

    for (let i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove(profileStyles.activated);
    }
    e.currentTarget.classList.add(profileStyles.activated);

    this.setState({
      displayMedias: false,
      displayAlbums: false,
      displayFavorites: false
    });
    switch (type) {
      case "FAVORITE":
        this.setState({ displayFavorites: true });
        break;
      case "ALBUM":
        this.setState({ displayAlbums: true });
        break;
      default:
        this.setState({ displayMedias: true });
        break;
    }
  };

  render() {
    const { displayMedias, displayAlbums, displayFavorites } = this.state;
    const {
      community,
      medias,
      favorites,
      albums,
      filter,
      fetchMyMedias
    } = this.props;
    let tabs = [];
    if (community) {
      const { mediaSettings } = community;
      tabs =
        mediaSettings &&
        mediaSettings.preferences &&
        mediaSettings.preferences.generalTypes
          ? mediaSettings.preferences.generalTypes.split(",")
          : [];
    }

    return (
      <div className={styles.myMedias}>
        <div className={styles.header}>
          <Profile
            onChangeTab={this.handleChangeTab}
            nbResult={{
              medias: medias.nbResult,
              favorites: favorites.nbResult,
              albums: albums.nbResult
            }}
          />
        </div>
        <div className={styles.body}>
          <div className={styles.filter}>
            <Filter
              tabs={tabs}
              filter={filter}
              fetchMedias={fetchMyMedias}
              withSearch={true}
            />
          </div>
          {displayMedias ? (
            <div className={styles.medias}>
              <MediaList medias={medias.items} fetching={medias.fetching} />
            </div>
          ) : null}
          {displayFavorites ? (
            <div className={styles.medias}>
              <MediaList medias={favorites.items} fetching={medias.fetching} />
            </div>
          ) : null}
          {displayAlbums ? (
            <div className={styles.medias}>
              <AlbumList albums={albums.items} fetching={albums.fetching} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyMedias/MyMediasComponent.js